import { useUserProfile } from './useUserProfile';
import { useAuth0Wrapper } from './auth0';
import { useDispatch, useSelector } from 'react-redux';
import { clearRVP } from '../state/recentlyViewedProducts/recentlyViewedProducts';
import { useCallback } from 'react';
import { parseValidJSON } from './parseValidJSON';
import { setRVPWithDetailedData } from '../state/recentlyViewedProducts/recentlyViewedProducts';

export const useRecentlyViewedProducts = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, authToken } = useAuth0Wrapper();
  const { addViewedProduct } = useUserProfile();

  const recentlyViewedProducts = useSelector(({ recentlyViewedProducts }) => recentlyViewedProducts);

  const deleteRecentlyViewedProducts = () => {
    dispatch(clearRVP());
  };

  const { removeViewedProducts } = useUserProfile();

  const deleteProducts = () => {
    if (!isAuthenticated) {
      localStorage.removeItem('rVP');
      deleteRecentlyViewedProducts();
      return;
    }

    removeViewedProducts();
  };

  const saveRecentlyViewedProductAnonymously = useCallback(
    (productId) => {
      try {
        const dt = new Date();
        const viewingDate = new Date(Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, 0, 0));
        const recentlyViewedProducts = parseValidJSON(localStorage.getItem('rVP')) || [];
        const hasProductInList = recentlyViewedProducts.some((item) => item.productId === productId);
        if (hasProductInList) return;

        recentlyViewedProducts.push({ date: viewingDate.toISOString().substr(0, 10), productId });
        const limitedRvp = recentlyViewedProducts.slice(-10);
        localStorage.setItem('rVP', JSON.stringify(limitedRvp));
        dispatch(setRVPWithDetailedData(limitedRvp, authToken));
      } catch (e) {
        console.error("Can't save RVP locally", e);
      }
    },
    [authToken, dispatch]
  );

  const saveRecentlyViewedProductToProfile = useCallback(
    (productId, profile) => {
      const hasRecentlyViewedProduct =
        profile?.recentlyViewedProducts &&
        profile.recentlyViewedProducts.some((product) => product.productId === productId);
      if (profile && !hasRecentlyViewedProduct) {
        addViewedProduct({
          body: JSON.stringify({ id: productId }),
        }).catch((reason) => {
          console.error("Can't save local rvp to profile:", reason);
        });
      }
    },
    [addViewedProduct]
  );

  return {
    recentlyViewedProducts: recentlyViewedProducts?.detailedList,
    recentlyViewedList: recentlyViewedProducts?.list,
    deleteProducts,
    saveRecentlyViewedProductToProfile,
    saveRecentlyViewedProductAnonymously,
  };
};
